function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useState, createContext } from "react";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import buildStyle, { defaultStyles } from "./ButtonGroup.style";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { DescendantProvider, useDescendantInit, createDescendantContext } from "../../Descendants";
import ButtonGroupItem from "../ButtonGroupItem/ButtonGroupItem";
import { ButtonGroupItemContextProvider } from "../ButtonGroupItem/index";
export var ButtonGroupContext = createContext(null);
export var ButtonGroupItemsContext = createDescendantContext('ButtonGroupItemsContext');
var ButtonGroup = function(param) {
    var children = param.children, onChange = param.onChange, _accessible = param.accessible, accessible = _accessible === void 0 ? true : _accessible, autoWidth = param.autoWidth, defaultSelected = param.defaultSelected, _iconAlign = param.iconAlign, iconAlign = _iconAlign === void 0 ? 'start' : _iconAlign, isRtl = param.isRtl, selectedProp = param.selected, _size = param.size, size = _size === void 0 ? 'm' : _size, testID = param.testID;
    var ref = _slicedToArray(useState(defaultSelected), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = _slicedToArray(useDescendantInit(), 2), items = ref1[0], setItems = ref1[1];
    var ref2;
    var styles = (ref2 = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref2 !== void 0 ? ref2 : defaultStyles;
    return _jsx(DescendantProvider, {
        context: ButtonGroupItemsContext,
        descendants: items,
        setDescendants: setItems,
        children: _jsx(ButtonGroupContext.Provider, {
            value: {
                isRtl: isRtl,
                iconAlign: iconAlign,
                autoWidth: autoWidth,
                size: size,
                selected: selectedProp !== null && selectedProp !== void 0 ? selectedProp : selected,
                itemStyles: styles.item,
                setSelected: setSelected,
                containerTestID: testID,
                onChange: onChange
            },
            children: _jsx("div", _objectSpread({}, injectTestId(testID), {
                role: "group",
                "aria-hidden": accessible ? undefined : true,
                dir: isRtl ? 'rtl' : 'ltr',
                css: styles.container.base,
                children: React.Children.map(children, function(child, index) {
                    var isFirst = index === 0;
                    var isLast = index === React.Children.count(children) - 1;
                    return _jsx(ButtonGroupItemContextProvider, {
                        value: {
                            isFirst: isFirst,
                            isLast: isLast
                        },
                        children: child
                    });
                })
            }))
        })
    });
};
export default ButtonGroup;
ButtonGroup.Item = ButtonGroupItem;
